import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Plane, Target, Handshake, Trophy } from 'lucide-react';

const CoupeDuMonde = () => {
 const [scrollY, setScrollY] = useState(0);
 const [isVisible, setIsVisible] = useState({});
 const sectionRefs = useRef([]);

 useEffect(() => {
 const handleScroll = () => {
 setScrollY(window.scrollY);
 sectionRefs.current.forEach((ref, index) => {
 if (ref) {
 const rect = ref.getBoundingClientRect();
 const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
 setIsVisible(prev => ({ ...prev, [index]: isInView }));
 }
 });
 };
 window.addEventListener('scroll', handleScroll);
 handleScroll();
 return () => window.removeEventListener('scroll', handleScroll);
 }, []);

 const packages = [
 {
 icon: '🏨',
 title: 'Hébergements Premium',
 description: 'Hôtels soigneusement sélectionnés avec confort et proximité des stades',
 },
 {
 icon: '🚐',
 title: 'Transferts VIP',
 description: 'Transports aéroport / hôtel / stade et déplacements inter-villes'
 },
 {
 icon: '👥',
 title: 'Assistance Dédiée',
 description: 'Équipes sur place disponibles 24/7 pour votre accompagnement'
 },
 {
 icon: '✨',
 title: 'Services Sur Mesure',
 description: 'Formules personnalisées adaptées à vos attentes et besoins'
 }
 ];

 const services = [
 { icon: <Plane />, text: 'Vols internationaux et internes', image: '/assets/img/coupe.jpg' },
 { icon: <Target />, text: 'Logistique et coordination des groupes', image: '/assets/img/coupe.jpg' },
 { icon: <Handshake />, text: 'Commercialisation et accompagnement', image: '/assets/img/coupe.jpg' },
 { icon: <Trophy />, text: 'Expertise événements sportifs majeurs', image: '/assets/img/coupe.jpg' }
 ];

 return (
 <div style={{ overflow: 'hidden', background: '#fff' }}>

 {/* ══ HERO ══ */}
 <div style={{
 position: 'relative', minHeight: '100vh', overflow: 'hidden',
 display: 'flex', alignItems: 'center', justifyContent: 'center'
 }}>
 <div style={{
 position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
 backgroundImage: 'url(/assets/img/coupe.png)',
 backgroundSize: 'cover', backgroundPosition: 'center',
 transform: `translateY(${scrollY * 0.5}px)`,
 }}/>
 <div style={{
 position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
 background: 'linear-gradient(135deg, rgba(118, 55, 79, 0.07) 0%, rgba(0, 0, 0, 0.61) 90%)'
 }}/>
 <div style={{
 position: 'relative', zIndex: 2, textAlign: 'center',
 padding: '0 20px', maxWidth: '1100px', animation: 'fadeInUp 1s ease-out'
 }}>
 <div style={{
 fontSize: '1.2rem', color: '#FFFFFF', fontWeight: '600',
 marginBottom: '20px', letterSpacing: '3px', textTransform: 'uppercase',
 animation: 'fadeIn 1.5s ease-out'
 }}>
 Agence N°1 du Tourisme Sportif en Tunisie
 </div>
 <h1 style={{
 fontSize: 'clamp(2.5rem, 6vw, 5rem)', fontWeight: '900', color: 'white',
 marginBottom: '30px', lineHeight: '1.2',
 textShadow: '0 10px 30px rgba(0,0,0,0.5)', animation: 'fadeInUp 1.2s ease-out'
 }}>
 COUPE DU MONDE<br/>FIFA 2026
 </h1>
 <p style={{
 fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', color: 'rgba(255,255,255,0.95)',
 marginBottom: '40px', fontWeight: '300', lineHeight: '1.8',
 animation: 'fadeInUp 1.4s ease-out'
 }}>
 États-Unis • Canada • Mexique
 </p>
 <div style={{
 display: 'flex', gap: '20px', justifyContent: 'center',
 flexWrap: 'wrap', animation: 'fadeInUp 1.6s ease-out'
 }}>
 <Link to="/#res" style={{
 padding: '18px 45px', fontSize: '1.1rem', fontWeight: '700',
 background: 'transparent', color: 'white', border: '3px solid white',
 borderRadius: '50px', cursor: 'pointer', transition: 'all 0.3s ease',
 textTransform: 'uppercase', letterSpacing: '1px'
 }}
 onMouseEnter={e => { e.target.style.background='white'; e.target.style.color='#1e3a5f'; e.target.style.transform='translateY(-5px)'; }}
 onMouseLeave={e => { e.target.style.background='transparent'; e.target.style.color='white'; e.target.style.transform='translateY(0)'; }}>
 Réserver Maintenant
 </Link>
 <a href="#pack">
 <button style={{
 padding: '18px 45px', fontSize: '1.1rem', fontWeight: '700',
 background: 'transparent', color: 'white', border: '3px solid white',
 borderRadius: '50px', cursor: 'pointer', transition: 'all 0.3s ease',
 textTransform: 'uppercase', letterSpacing: '1px'
 }}
 onMouseEnter={e => { e.target.style.background='white'; e.target.style.color='#1e3a5f'; e.target.style.transform='translateY(-5px)'; }}
 onMouseLeave={e => { e.target.style.background='transparent'; e.target.style.color='white'; e.target.style.transform='translateY(0)'; }}>
 Nos Packages
 </button>
 </a>
 </div>
 </div>
 <div style={{
 position: 'absolute', bottom: '30px', left: '50%',
 transform: 'translateX(-50%)', animation: 'bounce 2s infinite', zIndex: 2
 }}>
 <div style={{
 width: '40px', height: '40px', border: '3px solid white',
 borderRadius: '50%', display: 'flex', alignItems: 'center',
 justifyContent: 'center', color: 'white', fontSize: '1.5rem'
 }}>↓</div>
 </div>
 </div>

 {/* ══ INTRODUCTION ══ */}
 <div
 ref={el => sectionRefs.current[0] = el}
 style={{
 padding: '50px 20px',
 background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
 opacity: isVisible[0] ? 1 : 0,
 transform: isVisible[0] ? 'translateY(0)' : 'translateY(50px)',
 transition: 'all 1s ease-out'
 }}>
 <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
 <div style={{ textAlign: 'center', marginBottom: '60px' }}>
 <div style={{
 display: 'inline-block', padding: '10px 30px', color: '#00338C',
 borderRadius: '50px', fontSize: '0.9rem', fontWeight: '500',
 letterSpacing: '2px', marginBottom: '20px', textTransform: 'uppercase',
 fontFamily: 'Inter, sans-serif'
 }}>
 Aviator Travel Service
 </div>
 <h2 style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: 'clamp(2rem, 2.5vw, 3.5rem)', fontWeight: '700',
 color: '#01225C', marginBottom: '30px', lineHeight: '1.2',
 }}>
 Votre Partenaire d'Excellence pour la Coupe du Monde 2026
 </h2>
 <p style={{
 fontSize: '1.2rem', color: '#01225C', lineHeight: '1.8',
 maxWidth: '900px', margin: '0 auto',
 }}>
 Leader du tourisme sportif en Tunisie, nous vous invitons à vivre le plus grand événement sportif au monde.
 Forte d'une expérience confirmée dans la gestion des grands rendez-vous sportifs internationaux,
 Aviator Travel Service conçoit des packages entièrement personnalisés, alliant confort, flexibilité et excellence opérationnelle.
 </p>
 </div>

 <div style={{ marginTop: '80px' }}>
 <div style={{
 display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '30px',
 padding: '50px 0', borderBottom: '1px solid #CBDEFC', alignItems: 'start'
 }}>
 <h3 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#00338C', letterSpacing: '1px', textTransform: 'uppercase' }}>Match Unique</h3>
 <p style={{ fontSize: '1.1rem', color: '#01225C', lineHeight: '1.8' }}>
 Assistez à un match de votre choix avec un package sur mesure. Nous organisons votre voyage de A à Z : billets de match garantis, hébergement de qualité, transferts privés et assistance 24/7.
 </p>
 </div>
 <div style={{
 display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '60px',
 padding: '60px 0', borderBottom: '1px solid #CBDEFC', alignItems: 'start'
 }}>
 <h3 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#00338C', letterSpacing: '1px', textTransform: 'uppercase' }}>Suivez la Tunisie 🇹🇳</h3>
 <p style={{ fontSize: '1.1rem', color: '#01225C', lineHeight: '1.8' }}>
 Accompagnez l'équipe nationale durant toute la phase de poules. Package exclusif comprenant tous les matchs de la Tunisie, hébergement dans les villes de match, déplacements organisés entre les stades.
 </p>
 </div>
 <div style={{
 display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '60px',
 padding: '60px 0', alignItems: 'start'
 }}>
 <h3 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#00338C', letterSpacing: '1px', textTransform: 'uppercase' }}>Multi-Villes</h3>
 <p style={{ fontSize: '1.1rem', color: '#01225C', lineHeight: '1.8' }}>
 Découvrez plusieurs villes hôtes et vivez une expérience complète. Programme combiné vous permettant d'assister à plusieurs matchs dans différentes villes : New York, Los Angeles, Miami, Toronto, Mexico...
 </p>
 </div>
 </div>
 </div>
 </div>

 {/* ══ PACKAGES — nouveau design photo ══ */}
 <div
 id="pack"
 ref={el => sectionRefs.current[1] = el}
 style={{
 padding: '80px 20px 60px',
 background: '#EBF0FA',
 opacity: isVisible[1] ? 1 : 0,
 transform: isVisible[1] ? 'translateY(0)' : 'translateY(40px)',
 transition: 'opacity 0.8s ease, transform 0.8s ease',
 willChange: 'opacity, transform',
 fontFamily: 'Inter, sans-serif'
 }}
 >
 <div style={{ maxWidth: '860px', margin: '0 auto' }}>

 {/* Header */}
 <div style={{ textAlign: 'center', marginBottom: '50px' }}>
 <h2 style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: 'clamp(1.8rem, 3vw, 2.4rem)',
 fontWeight: '700',
 color: '#01225C',
 marginBottom: '12px',
 lineHeight: '1.2'
 }}>
 Nos Packages Incluent
 </h2>
 <p style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: '1rem',
 fontWeight: '400',
 color: '#00338C',
 margin: 0,
 lineHeight: '1.6'
 }}>
 Une expérience fluide, sécurisée et haut de gamme, du départ jusqu'au retour
 </p>
 </div>

 {/* Grid 2×2 */}
 <div style={{
 display: 'grid',
 gridTemplateColumns: 'repeat(2, 1fr)',
 gap: '20px',
 marginBottom: '40px'
 }}>
 {packages.map((pkg, index) => (
 <div
 key={index}
 style={{
 background: '#ffffff',
 borderRadius: '8px',
 padding: '36px 32px',
 boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
 transition: 'box-shadow 0.25s, transform 0.25s',
 cursor: 'default',
 textAlign: 'center'
 }}
 onMouseEnter={e => {
 e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,51,140,0.12)';
 e.currentTarget.style.transform = 'translateY(-3px)';
 }}
 onMouseLeave={e => {
 e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.06)';
 e.currentTarget.style.transform = 'translateY(0)';
 }}
 >
 <h3 style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: '1.5rem',
 fontWeight: '600',
 color: '#00338C',
 marginBottom: '14px',
 marginTop: 0
 }}>
 {pkg.title}
 </h3>
 <p style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: '0.92rem',
 fontWeight: '400',
 color: '#01225C',
 lineHeight: '1.7',
 margin: 0
 }}>
 {pkg.description}
 </p>
 </div>
 ))}
 </div>

 {/* Bouton Réserver centré */}
 <div style={{ textAlign: 'center' }}>
 <Link
 to="/#res"
 style={{
 display: 'inline-block',
 padding: '14px 48px',
 fontFamily: 'Inter, sans-serif',
 fontSize: '1rem',
 fontWeight: '700',
 background: '#01225C',
 color: '#ffffff',
 borderRadius: '10px',
 textDecoration: 'none',
 transition: 'all 0.2s ease',
 }}
 onMouseOver={e => {
 e.currentTarget.style.setProperty('color', '#FFBC1E', 'important');
 e.currentTarget.style.transform = 'translateY(-2px)';
 }}
 onMouseOut={e => {
 e.currentTarget.style.setProperty('color', '#ffffff', 'important');
 e.currentTarget.style.transform = 'translateY(0)';
 }}
 >
 Réserver
 </Link>
 </div>

 </div>
 </div>

 {/* ══ BANNIERE COUPE DU MONDE CUSTOM ══ */}
 <div style={{ padding: '80px 20px', background: '#FAFAFA', textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>
 <h2 style={{
 fontSize: 'clamp(2rem, 3.5vw, 2.5rem)', fontWeight: '700', color: '#01225C',
 margin: '0 auto 40px', lineHeight: '1.4' // added spacing
 }}>
 Vivez l'excitation de la Coupe du Monde<br/>
 avec nos voyages organisés
 </h2>

 <div style={{
 maxWidth: '1000px', margin: '0 auto',
 borderRadius: '16px', overflow: 'hidden', position: 'relative',
 boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
 minHeight: '450px', display: 'flex', flexDirection: 'column',
 alignItems: 'center', justifyContent: 'center', padding: '40px',
 }}>
 {/* Back image */}
 <div style={{
 position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
 backgroundImage: 'url(/assets/img/coupe2.png)',
 backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0
 }}/>
 <div style={{
 position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
 background: 'rgba(0,0,0,0.7)', zIndex: 1
 }}/>

 {/* Content */}
 <div style={{ position: 'relative', zIndex: 2, color: 'white', maxWidth: '850px', width: '100%' }}>
 <h3 style={{ fontSize: 'clamp(2.2rem, 4vw, 3rem)', fontWeight: '700', marginBottom: '15px' , color: 'white' }}>
 Coupe du Monde 2026
 </h3>
 
 <div style={{ fontSize: '1.1rem', fontWeight: '500', marginBottom: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
 <i className="fa fa-map-marker-alt"></i> USA et Mexique
 </div>

 <p style={{
 fontSize: '0.95rem', lineHeight: '1.8', marginBottom: '30px', 
 color: '#FFFFFF', padding: '0 20px'
 }}>
 Vivez l'aventure ultime du football en assistant à la Coupe du Monde 2026 aux États-Unis et au Mexique !<br/>
 Profitez des stades modernes américains et de l'ambiance chaude et festive du Mexique, tout en découvrant<br/>
 les villes emblématiques et la culture nord-américaine. ⚽✈️
 </p>

 <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginBottom: '35px', fontSize: '0.95rem', color: 'rgba(255,255,255,0.9)' }}>
 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
 <i className="fa fa-calendar-alt"></i> 12 juin 2026
 </div>
 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
 <i className="fa fa-users"></i> 20 places disponibles
 </div>
 </div>

 <button style={{
 display: 'inline-block', padding: '12px 35px', backgroundColor: '#00338C',
 color: 'white', borderRadius: '8px', fontWeight: '600', textDecoration: 'none',
 border: 'none', transition: 'background 0.3s', cursor: 'pointer'
 }}
 onMouseEnter={e => e.currentTarget.style.backgroundColor = '#01225C'}
 onMouseLeave={e => e.currentTarget.style.backgroundColor = '#00338C'}>
 Voir les détails
 </button>
 </div>
 </div>
 </div>

 {/* ══ SERVICES ══ */}
 <div
 ref={el => sectionRefs.current[2] = el}
 style={{
 padding: '120px 20px',
 background: '#ffffff',
 opacity: isVisible[2] ? 1 : 0,
 transform: isVisible[2] ? 'translateY(0)' : 'translateY(50px)',
 transition: 'all 1s ease-out'
 }}>
 <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
 <div style={{
 display: 'grid',
 gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
 gap: '50px', alignItems: 'center'
 }}>
 <div>
 <div style={{
 display: 'inline-block', padding: '8px 0px', 
 color: '#00338C', borderRadius: '50px', fontSize: '0.85rem',
 fontWeight: '700', letterSpacing: '1px', marginBottom: '20px', textTransform: 'uppercase',
 fontFamily: 'Inter, sans-serif',
 }}>
 Organisation Complète
 </div>
 <h2 style={{
 fontSize: 'clamp(2rem, 4vw, 2rem)', fontWeight: '900',
 color: '#01225C', marginBottom: '30px', lineHeight: '1.3'
 }}>
 Nous Prenons Tout en Charge
 </h2>
 <p style={{
 fontSize: '1.1rem', color: '#01225C', lineHeight: '1.8', marginBottom: '40px'
 }}>
 De la planification à l'exécution, chaque détail est géré par nos équipes expertes pour vous garantir une expérience sans souci.
 </p>
 {services.map((service, index) => (
 <div
 key={index}
 style={{
 display: 'flex', alignItems: 'center', gap: '20px',
 padding: '20px', borderRadius: '15px', marginBottom: '15px',
 cursor: 'pointer', overflow: 'hidden',
 backgroundImage: `linear-gradient(rgba(43,76,126,0.85),rgba(43,76,126,0.85)), url(${service.image})`,
 backgroundSize: 'cover', backgroundPosition: 'center',
 transition: 'all 0.3s ease',
 animation: `slideInLeft 0.6s ease-out ${index * 0.1}s both`
 }}
 onMouseEnter={e => { e.currentTarget.style.transform='translateX(10px)'; e.currentTarget.style.boxShadow='0 10px 30px rgba(43,76,126,0.35)'; }}
 onMouseLeave={e => { e.currentTarget.style.transform='translateX(0)'; e.currentTarget.style.boxShadow='none'; }}
 >
 <div style={{
 width: '50px', height: '50px', background: 'rgba(225,243,249,0.95)',
 borderRadius: '50%', display: 'flex', alignItems: 'center',
 justifyContent: 'center', fontSize: '1.5rem', flexShrink: 0
 }}>
 {service.icon}
 </div>
 <p style={{
 margin: 0, fontSize: '1.1rem', fontWeight: '600',
 color: '#ffffff', textShadow: '0 2px 4px rgba(0,0,0,0.4)'
 }}>
 {service.text}
 </p>
 </div>
 ))}
 </div>

 <div style={{
 position: 'relative', borderRadius: '12px', overflow: 'hidden',
 boxShadow: '0 30px 60px rgba(0,0,0,0.2)', height: '600px'
 }}>
 <img
 src="/assets/img/coupe3.png"
 alt="World Cup Stadium"
 style={{ width: '100%', height: '100%', objectFit: 'cover' }}
 />
 <div style={{
 position: 'absolute', bottom: '0', left: '0', right: '0', padding: '40px',
 background: 'linear-gradient(to top, rgba(43,76,126,0.95) 0%, transparent 100%)',
 color: 'white'
 }}>
 <h3 style={{ fontSize: '1.8rem', fontWeight: '700', marginBottom: '10px' , color : '#F5F5F5' }}>
 Expertise Reconnue
 </h3>
 <p style={{ fontSize: '1rem', opacity: 0.95, lineHeight: '1.6' }}>
 Présence continue sur les plus grands événements sportifs : Coupes du Monde, Champions League, Jeux Olympiques
 </p>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* ══ CTA ══ */}
 <div
 ref={el => sectionRefs.current[3] = el}
 style={{
 padding: '120px 20px',
 background: 'linear-gradient(135deg, #002e7e 0%, #002E7EBF 100%)',
 position: 'relative', overflow: 'hidden',
 opacity: isVisible[3] ? 1 : 0,
 transform: isVisible[3] ? 'scale(1)' : 'scale(0.95)',
 transition: 'all 1s ease-out'
 }}>
 <div style={{
 position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
 backgroundImage: 'url(/assets/img/coupe4.png)',
 backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.20,
 
 }}/>
 <div style={{
 maxWidth: '80vw', margin: '0 auto', textAlign: 'center',
 position: 'relative', zIndex: 1
 }}>
 <h2 style={{
 fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '900',
 color: 'white', marginBottom: '30px', lineHeight: '1.2',
 fontFamily: 'Inter, sans-serif',
 }}>
 Vivez l'Intensité.<br/>Ressentez la Passion.
 </h2>
 <p style={{
 fontSize: '1.3rem', color: '#FFFFFF',
 marginBottom: '50px', lineHeight: '1.8',
 fontFamily: 'Inter, sans-serif',
 }}>
 Avec Aviator Travel Service, la Coupe du Monde FIFA 2026 devient bien plus qu'un voyage :
 une expérience sportive inoubliable, pensée et organisée par le spécialiste N°1 du tourisme sportif en Tunisie.
 </p>
 <Link
 to="/contact"
 style={{
 display: 'inline-block',
 padding: 'clamp(15px, 3vw, 25px) clamp(30px, 2vw, 60px)',
 fontSize: 'clamp(1rem, 2vw, 1rem)', fontWeight: '700',
 background: 'transparent',
 color: 'white', border: '1px solid white', borderRadius: '50px',
 cursor: 'pointer', transition: 'all 0.4s ease',
 textTransform: 'uppercase', letterSpacing: 'clamp(1px, 0.2vw, 2px)',
 textDecoration: 'none', textAlign: 'center', whiteSpace: 'nowrap'
 }}
 onMouseEnter={e => { e.currentTarget.style.background='white'; e.currentTarget.style.color='#1e3a5f'; e.currentTarget.style.transform='translateY(-3px)'; }}
 onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='white'; e.currentTarget.style.transform='translateY(0)'; }}
 >
 Contactez-Nous Maintenant
 </Link>
 </div>
 </div>

 <style>{`
 @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
 @keyframes fadeInUp {
 from { opacity: 0; transform: translateY(40px); }
 to { opacity: 1; transform: translateY(0); }
 }
 @keyframes slideInLeft {
 from { opacity: 0; transform: translateX(-50px); }
 to { opacity: 1; transform: translateX(0); }
 }
 @keyframes bounce {
 0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
 40% { transform: translateX(-50%) translateY(-10px); }
 60% { transform: translateX(-50%) translateY(-5px); }
 }
 @media (max-width: 600px) {
 #pack > div > div[style*="grid-template-columns: repeat(2"] {
 grid-template-columns: 1fr !important;
 }
 }
 `}</style>
 </div>
 );
};

export default CoupeDuMonde;